export function setupEncuesta() {
    const encuestas = document.querySelectorAll(".encuesta");

    if (!encuestas) return;
    // console.log(readCookie("dcvv"));
    if (typeof readCookie("dcvv") != "undefined") {
        encuestas[0].classList.add("encuesta--mostrar_resultados");
        return;
    }
    for (const encuesta of encuestas) {
        const botones = encuesta.querySelectorAll("button");
        for (const boton of botones) {
            boton.addEventListener("click", function (e) {
                this.closest(".encuesta").classList.add(
                    "encuesta--mostrar_resultados"
                );

                fetch(
                    "/wp-admin/admin-ajax.php?action=encuesta&o=" +
                        boton.dataset.id +
                        "&pid=" +
                        boton.dataset.pid
                );
            });
        }
    }
}
var cookies;
function readCookie(name, c, C, i) {
    if (cookies) {
        return cookies[name];
    }

    c = document.cookie.split("; ");
    cookies = {};

    for (i = c.length - 1; i >= 0; i--) {
        C = c[i].split("=");
        cookies[C[0]] = C[1];
    }

    return cookies[name];
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
